
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import { 
  Filter, 
  Plus, 
  Search,
  SlidersHorizontal,
  Music,
  Calendar,
  FileText
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const Releases: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  
  // Empty releases array
  const releases = [];
  
  return (
    <Layout>
      <div className="px-4 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8 animate-fade-in">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold flex items-center gap-2">
              <Music className="h-7 w-7 text-muted-foreground" />
              Music Releases
            </h1>
            <p className="text-muted-foreground">Manage your singles, EPs, and albums</p>
          </div>
          
          <Button className="gap-2" asChild>
            <Link to="/releases/new">
              <Plus className="h-4 w-4" />
              <span>New Release</span>
            </Link>
          </Button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-4 mb-6 animate-slide-up">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input 
              placeholder="Search releases..." 
              className="pl-9 glass-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          
          <Button variant="outline" className="gap-2">
            <Filter className="h-4 w-4" />
            <span className="hidden sm:inline">Filter</span>
            <SlidersHorizontal className="h-4 w-4 sm:hidden" />
          </Button>
        </div>
        
        <Tabs 
          defaultValue="all" 
          className="mb-6 animate-slide-up"
          onValueChange={setActiveTab}
        >
          <TabsList className="grid grid-cols-4 w-full sm:w-fit">
            <TabsTrigger value="all">All</TabsTrigger>
            <TabsTrigger value="singles">Singles</TabsTrigger>
            <TabsTrigger value="eps">EPs</TabsTrigger>
            <TabsTrigger value="albums">Albums</TabsTrigger>
          </TabsList>
          
          <div className="flex flex-wrap gap-2 mt-4">
            <Badge variant="outline" className="flex items-center gap-1">
              <Calendar className="h-3 w-3" />
              <span>Release Date</span>
            </Badge>
            <Badge variant="outline" className="flex items-center gap-1">
              <FileText className="h-3 w-3" />
              <span>Status</span>
            </Badge>
          </div>
        </Tabs>
        
        <div className="text-center py-16 animate-fade-in">
          <Music className="h-16 w-16 mx-auto mb-4 opacity-20" />
          <h3 className="text-lg font-medium mb-2">No releases found</h3>
          <p className="text-muted-foreground mb-6">
            Create your first release to get started
          </p>
          <Button className="gap-2" asChild>
            <Link to="/releases/new">
              <Plus className="h-4 w-4" />
              <span>Create New Release</span>
            </Link>
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default Releases;
